import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './admin-login.component.html',
  styleUrl: './admin-login.component.scss'
})
export class AdminLoginComponent {
  private fb = inject(FormBuilder);
  private router = inject(Router);

  loginForm: FormGroup = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required]
  });

  errorMessage = signal<string>('');

  private setAuthAndNavigate(token?: string) {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem('ambition_local_auth', 'true');
      localStorage.setItem('ambition_admin_token', token || ('token_' + Date.now()));
    }
    this.router.navigate(['/admin/dashboard']);
  }

  onSubmit() {
    if (this.loginForm.invalid) return;

    const username = this.loginForm.value.username?.trim();
    const password = this.loginForm.value.password;
    this.errorMessage.set('');

    // 1. Master Admin Fallback Credentials Check
    if (username === 'admin' && password === 'admin123') {
      this.setAuthAndNavigate('master_token_admin');
      return;
    }

    // 2. Local Created Users Lookup
    if (typeof window !== 'undefined' && window.localStorage) {
      const localAuth = JSON.parse(localStorage.getItem('ambition_local_auth_list') || '{}');
      if (localAuth[username] && localAuth[username] === password) {
        this.setAuthAndNavigate('local_token_' + Date.now());
        return;
      }
    }

    // 3. Live PHP MySQL Backend Authentication
    const isLocalhost = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
    const authUrl = isLocalhost ? 'https://demo.ambitionbuilt.com.au/api/auth.php' : '/api/auth.php';

    fetch(authUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    })
      .then(res => res.json())
      .then(resData => {
        if (resData.status === 'success') {
          this.setAuthAndNavigate(resData.token);
        } else {
          this.errorMessage.set(resData.message || 'Invalid username or password.');
        }
      })
      .catch(() => {
        this.errorMessage.set('Invalid username or password.');
      });
  }
}
